export default {
  client_id: 6482863,
  redirect_url: 'https://startler.ru/vk',
  login_url: 'https://startler.ru/vk/vkLogin.php',
  api_ver: '5.81'
}



// WEBPACK FOOTER //
// ./src/config.js